import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";

import Login from "pages/hospital/Login";
import Join from "pages/hospital/Join";
import Hospital from "pages/hospital/Hospital";
import Review from "pages/hospital/Review";
import ReviewDetail from "pages/hospital/ReviewDetail";
import Event from "pages/hospital/Event";
import Doctor from "pages/hospital/Doctor";
import Youtube from "pages/hospital/Youtube";

import CommonEvent from "component/common/commonEvent";

import "assets/css/hospital/common.scss";
import "assets/css/hospital/pages/hospital.scss";
import "assets/css/hospital/pages/review.scss";
import "assets/css/hospital/pages/login.scss";

const HospitalRouter = () => {
  useEffect(() => {
    document.body.parentElement.style.height = "100%";
    document.body.style.height = "100%";
    document.getElementById("root").style.height = "100%";
  }, []);

  return (
    <div className="hospital-wrap">
      <Switch>
        <Route exact path="/hospital/:cid/login" component={Login} />
        <Route exact path="/hospital/:cid/join" component={Join} />
        <Route exact path="/hospital/:cid" component={Hospital} />
        <Route exact path="/hospital/:cid/review" component={Review} />
        <Route exact path="/hospital/:cid/review/detail/:id" component={ReviewDetail} />
        <Route path="/hospital/:cid/event" component={Event} />
        <Route path="/hospital/:cid/doctor" component={Doctor} />
        <Route path="/hospital/:cid/youtube" component={Youtube} />
      </Switch>

      {/* 모든 페이지 공통 이벤트 */}
      <CommonEvent />
    </div>
  );
};

export default HospitalRouter;
